/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-analysis-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-analysis-api-client";
import type { StationSettingsClientControllerGetSettingsQueryResponse, StationSettingsClientControllerGetSettingsPathParams } from "../models/StationSettingsClientControllerGetSettings";

function getStationSettingsClientControllerGetSettingsUrl(entityId: StationSettingsClientControllerGetSettingsPathParams["entityId"]) {
  const res = { method: 'GET', url: `/station-settings/${entityId}` as const }  
  return res
}

/**
 * @description Get settings for a specific station (client access)
 * @summary Get station settings
 * {@link /station-settings/:entityId}
 */
export async function stationSettingsClientControllerGetSettings(entityId: StationSettingsClientControllerGetSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<StationSettingsClientControllerGetSettingsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStationSettingsClientControllerGetSettingsUrl(entityId).url.toString(), ... requestConfig })  
  return res.data
}